import React from 'react'
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material'

export interface OccupationType {
  id: number
  short_code: string
  desc: string
}

export const occupationTypeOptions = new Map<number, OccupationType>([
  [1, { id: 1, short_code: 'ACT', desc: 'Actor/Entertainer' }],
  [2, { id: 2, short_code: 'AER', desc: 'Aeronautics' }],
  [3, { id: 3, short_code: 'AGR', desc: 'Agriculture' }],
  [25, { id: 25, short_code: 'BAN', desc: 'Banker' }],
  [26, { id: 26, short_code: 'BRO', desc: 'Broadcaster' }],
  [4, { id: 4, short_code: 'BUS', desc: 'Business' }],
  [5, { id: 5, short_code: 'CLE', desc: 'Clergy' }],
  [6, { id: 6, short_code: 'EDU', desc: 'Education' }],
  [7, { id: 7, short_code: 'ENG', desc: 'Engineering' }],
  [8, { id: 8, short_code: 'HOM', desc: 'Homemaker' }],
  [9, { id: 9, short_code: 'JOU', desc: 'Journalism' }],
  [10, { id: 10, short_code: 'LAB', desc: 'Labor' }],
  [11, { id: 11, short_code: 'LEN', desc: 'Law Enforcement' }],
  [12, { id: 12, short_code: 'LOB', desc: 'Lobbyist' }],
  [13, { id: 13, short_code: 'LAW', desc: 'Legal' }],
  [14, { id: 14, short_code: 'MED', desc: 'Medicine/Healthcare' }],
  [15, { id: 15, short_code: 'MIL', desc: 'Military' }],
  [16, { id: 16, short_code: 'PRO', desc: 'Professional Sports' }],
  [17, { id: 17, short_code: 'PUB', desc: 'Public Official' }],
  [18, { id: 18, short_code: 'REL', desc: 'Real Estate' }],
  [19, { id: 19, short_code: 'ENT', desc: 'Entertainment' }],
  [23, { id: 23, short_code: 'VOL', desc: 'Volunteer/Advocate' }],
  [24, { id: 24, short_code: 'OTH', desc: 'Other' }]
])

export const OccupationTypeSelect: React.FC<{ value: OccupationType | null, updateOccupationType: (occupationType: OccupationType | null) => void, disabled: boolean }> = ({ value, updateOccupationType, disabled }) => {
  const handleChange = (value: string | number): void => {
    const selectedOption = occupationTypeOptions.get(value as number)
    updateOccupationType(selectedOption ?? null)
  }

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="occupation-type-select-label">Occupation Type</InputLabel>
      <Select
        labelId="occupation-type-select-label"
        label="Occupation Type"
        value={(value != null) ? value.id : ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
        fullWidth
      >
        {Array.from(occupationTypeOptions.values()).map((occupationType) => (
          <MenuItem key={occupationType.id} value={occupationType.id}>
            {occupationType.desc}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
